document.querySelectorAll('[data-hero-slideshow]').forEach((hero) => {
  const slides = hero.querySelectorAll('[data-hero-slide]');
  const prevBtn = hero.querySelector('[data-hero-prev]');
  const nextBtn = hero.querySelector('[data-hero-next]');
  const dots = hero.querySelectorAll('[data-hero-dot]');
  const autoplay = hero.dataset.autoplay !== 'false';
  const duration = parseInt(hero.dataset.duration || '5', 10) * 1000;

  if (slides.length <= 1) return;

  let currentIndex = 0;
  let timerId = null;

  function showSlide(index) {
    if (index >= slides.length) index = 0;
    if (index < 0) index = slides.length - 1;
    currentIndex = index;
    slides.forEach((s, i) => s.classList.toggle('is-active', i === currentIndex));
    dots.forEach((d, i) => d.classList.toggle('is-active', i === currentIndex));
  }

  function next() {
    showSlide(currentIndex + 1);
    resetTimer();
  }

  function prev() {
    showSlide(currentIndex - 1);
    resetTimer();
  }

  function resetTimer() {
    if (timerId) clearInterval(timerId);
    if (autoplay) {
      timerId = setInterval(next, duration);
    }
  }

  prevBtn?.addEventListener('click', prev);
  nextBtn?.addEventListener('click', () => { next(); });

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      showSlide(i);
      resetTimer();
    });
  });

  hero.addEventListener('mouseenter', () => { if (timerId) clearInterval(timerId); });
  hero.addEventListener('mouseleave', resetTimer);

  resetTimer();
});
